import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'newTypes/RootState';
import { initialState } from './slice';

const selectDomain = (state: RootState) => {
  console.log('state', state.AuthState);

  if (state) {
    if (state.AuthState) {
      return state.AuthState;
    } else {
      return initialState;
    }
  } else {
    return initialState;
  }
};
export const selectLoginForm = createSelector([selectDomain], (state) => state.loginFrom);
export const selectIsLogin = createSelector([selectDomain], (state) => state.isLogin);
export const selectUserData = createSelector([selectDomain], (state) => state.userData);
export const selectUpdatePassword = createSelector([selectDomain], (state) => state.updatePasswordFormData);
export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectStaffPermishion = createSelector([selectDomain], (state) => state.form);
